module.exports = __webpack_public_path__ + "img/tips.9433033b.png";